import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function ApparelDesign() {
  return (
    <div id="top">
      <div id="wrapper">
        <Header />
        <div id="navig_inside">
          <Navigation />
        </div>
        <div id="banner"></div>
        <div id="inside_page" className="bodyText">
          <div id="page1">
            <span className="bodyText">
              <p className="welcome_heading"><strong>Apparel Design &amp; Fabrication Technology </strong></p>
            </span><span className="bodyText">
              <div className="clear"></div>
            </span>
            <div id="apparel_right">
              <p><img src="/images/apparel.png" width="264" height="252" alt="Apparel Design" /></p>
              <p>&nbsp;</p>
            </div>
            <div id="apparel">
              <ul className="apparel">
                <li>Intake of 27 students.</li>
                <li>Specialized course that helps to exhibit ones idea about new and special creations.</li>
                <li>Curriculum includes subjects on Fibre Science, Fashion Designing, Quality Management, Fabric Designing, Surface Ornamentation, Fashion Illustration etc. CAD Design &amp; pattern making software used in the institute is one of the best and widely used by the International Apparel Industry.</li>
                <li>Well-equipped laboratories with state of art power operated machines used in the industry.</li>
                <li>Qualified &amp; well experienced staff.</li>
                <li>Training in reputed industries. </li>
                <li>Regular Participation in Fashion shows/Competitions by students.</li>
                <li>Free Internet facility for all students (with Digital Library facility).</li>
                <li>Innovation Centre/Tinkering Lab facility. </li>
              </ul>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default ApparelDesign;
